const API =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_STRAPI_URL) ||
  process.env.REACT_APP_STRAPI_URL ||
  process.env.NEXT_PUBLIC_STRAPI_URL ||
  "http://localhost:1337";

export async function fetchTransitDepartures() {
  const response = await fetch(`${API}/api/wiener-linien/departures`);

  // 503 = our controlled timeout, 500 = other Strapi error — both mean
  // live data is temporarily unavailable, not a hard failure.
  if (response.status === 503 || response.status === 500) {
    return { stops: [], departures: {}, unavailable: true };
  }

  if (!response.ok) {
    throw new Error(`Strapi Wiener Linien ${response.status}`);
  }

  return response.json();
}